<template>
  <v-card>
    <v-overlay z-index="10000" :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <v-tabs
      v-model="currentTab"
      @change="onTabChange"
      background-color="primary"
      dark
    >
      <v-tab
        v-for="item in referentials"
        :key="item.name"
        v-show="item.divisions.includes(currentDivision)"
      >
        {{ currentDivision === '3DIV' ? 'pearl' : currentDivision }}
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <CustomJsonEditor
        v-model="dialog"
        :referential="currentReferential"
        :action="crudAction"
        :data="crudItem"
      ></CustomJsonEditor>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tab-item v-for="item in referentials" :key="item.name">
        <v-card flat>
          <v-card-title>
            <v-text-field
              append-icon="mdi-magnify"
              label="code"
              single-line
              hide-details
              class="ml-1"
              @input="handleSearchInput"
              v-model="searchQuery"
            />
            <v-spacer></v-spacer>
          </v-card-title>
          <v-btn @click="newItem" color="primary" dark class="ml-5 mb-2">
            new {{ `${buttonText} ${item.elementName}` }}
          </v-btn>
          <v-btn @click="resetSearch" color="primary" dark class="ml-5 mb-2">
            clear search reset
          </v-btn>
          <v-btn @click="downloadItem" color="primary" dark class="ml-5 mb-2">
            export
          </v-btn>
          <v-data-table
            :headers="currentReferential.headers"
            :items="responseData.content"
            single-expand
            :expanded.sync="expanded"
            :items-per-page="pageSize"
            :hide-default-footer="true"
            show-expand
            disable-sort
            item-key="code"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat></v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete</v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <ace-editor
                  :content="JSON.stringify(item, undefined, 4)"
                  readOnly
                />
              </td>
            </template>
          </v-data-table>
          <v-pagination
            v-model="page"
            :length="pages"
            :page="page"
            :total-visible="7"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          ></v-pagination>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import referentials from '@/views/Referentials/referentials.json';
import CustomJsonEditor from '@/views/Referentials/common/CustomJsonEditor';
import AceEditor from '@/components/AceEditor';
import config from '@/utils/config';
import axios from '@/utils/axios';

const {mapState, mapActions} = createNamespacedHelpers('referentials');
const {mapState: mapStateConfig} = createNamespacedHelpers('config');

export default {
  components: {
    CustomJsonEditor,
    AceEditor
  },
  name: 'Referentials',
  data() {
    return {
      page: 1,
      pageSize: 15,
      pages: 1,
      crudAction: '',
      referentials: referentials,
      expanded: [],
      singleExpand: true,
      defaultItem: {},
      crudItem: {},
      currentReferential: null,
      currentTab: null,
      dialog: false,
      dialogDelete: false,
      ressourceUrl: null,
      timer: null,
      searchQuery: ''
    };
  },
  props: {},
  watch: {
    dialogDelete: {
      handler(val) {
        val || this.closeDelete();
      }
    },
    page: {
      handler() {
        if (this.searchQuery === '') {
          this.loadTableData();
        } else {
          this.currentReferential.pageNumber = this.page - 1;
          this.loadTableData(
            this.currentReferential.url,
            this.currentReferential.pageNumber
          );
        }
      }
    },
    currentDivision: {
      async handler(newDivisionValue) {
        this.currentTab = 0;
        this.currentReferential = this.referentials[0];
        this.currentReferential = {
          ...this.currentReferential,
          currentDivision: newDivisionValue
        };
        this.loadTableData();
        await this.getFullReferentialData(this.currentReferential);
        this.page = 1;
        this.pages = this.totalPages;
        this.searchQuery = '';
      }
    }
  },
  created() {
    this.initialize();
  },
  computed: {
    ...mapState([
      'responseData',
      'totalElements',
      'totalPages',
      'loading',
      'fullReferentials'
    ]),
    ...mapStateConfig(['entities', 'currentDivision']),
    buttonText: function () {
      if (this.currentDivision === '3DIV') {
        return 'pearl';
      } else {
        return this.currentDivision.toLowerCase();
      }
    }
  },
  methods: {
    ...mapActions([
      'getReferentialData',
      'getFullReferentialData',
      'deleteReferential',
      'resetResponseDataContent',
      'resetFullReferentialResponseDataContent'
    ]),
    initialize() {
      this.currentTab = 0;
      this.currentReferential = referentials[0];
      this.loadTableData();
      this.getFullReferentialData(this.currentReferential);
    },
    async loadTableData(url, page = 0) {
      this.handleCurrentReferentialChange(url, page);
      if (this.checkIfReferentialExists(this.currentDivision)) {
        await this.getReferentialData(this.currentReferential);
        this.pages = this.totalPages;
      } else {
        this.resetResponseDataContent();
        this.page = 1;
        this.pages = this.totalPages;
      }
    },
    async onTabChange(val) {
      this.currentTab = val;
      this.currentReferential = this.referentials[val];
      this.loadTableData();
      await this.getFullReferentialData(this.currentReferential);
      this.page = 1;
      this.pages = this.totalPages;
      this.searchQuery = '';
    },
    newItem() {
      this.handleCurrentReferentialChange();
      this.crudAction = 'create';
      this.crudItem = {
        code: ''
      };
      this.dialog = true;
    },
    editItem(item) {
      this.handleCurrentReferentialChange();
      this.crudAction = 'edit';
      this.editedIndex = this.referentials.indexOf(item);
      this.crudItem = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.referentials.indexOf(item);
      this.crudItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      let params = {
        referentialUri: this.ressourceUrl,
        referentialCode: this.crudItem.code
      };
      await this.deleteReferential(params);
      this.loadTableData();
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.crudItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    handleCurrentReferentialChange(url, localPageNumber) {
      if (url && url !== '') {
        this.currentReferential.url = url;
      } else {
        if (this.currentDivision === '3DIV') {
          this.ressourceUrl = `/pearl/${this.currentReferential.name.toLowerCase()}`;
        } else {
          this.ressourceUrl =
            `/${this.currentDivision.toLowerCase()}` +
            `/${this.currentReferential.name.toLowerCase()}`;
        }
        this.currentReferential.url = this.ressourceUrl;
      }
      if (localPageNumber && localPageNumber !== '') {
        this.currentReferential.pageNumber = localPageNumber;
      } else {
        this.currentReferential.pageNumber = this.page - 1;
      }
      this.currentReferential.pageSize = this.pageSize;
    },
    checkIfReferentialExists(ref) {
      return this.currentReferential.divisions.includes(ref);
    },
    debounce(func, timeout) {
      return (...args) => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => func(...args), timeout);
      };
    },
    handleSearchInput(searchString) {
      const processChange = this.debounce(this.doSearch, 500);
      processChange(searchString);
    },
    async doSearch(searchString) {
      if (searchString && searchString !== '') {
        const codes = this.fullReferentials.content.filter(
          ref => ref.code.toLowerCase().includes(searchString.toLowerCase()) ||
            this.checkIfInputExistsInReferentialDataflow(ref, searchString)
        ).map(ref => ref.code).join(',');
        if (codes.length > 0) {
          this.handleCurrentReferentialChange(undefined, this.page - 1);
          const searchResource = `${this.currentReferential.url}?codes=${codes}`;
          this.loadTableData(searchResource, 0);
          this.pages = this.totalPages;
        } else {
          this.resetResponseDataContent();
          this.pages = 1;
        }
        this.page = 1;
      }
    },
    checkIfInputExistsInReferentialDataflow(ref, input) {
      return Object.keys(ref).some(key => {
        if (key && key.match(/dataflow/gi)) {
          if (typeof ref[key] === 'object' && !Array.isArray(ref[key])) {
            return ref[key].code && ref[key].code.toLowerCase().includes(input);
          } else if (Array.isArray(ref[key])) {
            return ref[key].some(
              el => el.code && el.code.toLowerCase().includes(input)
            );
          } else {
            return false;
          }
        }
      });
    },
    resetSearch() {
      if ('content' in this.fullReferentials) {
        this.loadTableData();
        this.page = 1;
        this.pages = this.totalPages;
        this.searchQuery = '';
      }
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const filename = "referentials-" + (this.currentDivision === '3DIV' ? 'pearl'
        : this.currentDivision) + "-" + this.currentReferential.name + ".json"
      link.href = url;
      link.setAttribute('download', filename.toLowerCase());
      document.body.appendChild(link);
      link.click();
    },
    downloadItem() {
      const url = config.BACKEND_BASE_URL + this.currentReferential.url + '/export';
      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        this.forceFileDownload(response);
      }).catch((e) => console.log('error occured : ' + e.message))
    }
  }
};
</script>
<style></style>
